module.exports = __webpack_public_path__ + "img/bleu_fonce_1380.c9624b54.jpg";